import { TextField, InputAdornment } from "@mui/material";

// Reusable euro currency field built on MUI TextField
export function EuroField({ label, name, value, onChange, disabled = false }) {
    // const handleChange = (e) => {
    //     if (!onChange) return;
    //     const raw = e.target.value.replace(/[^\d,.-]/g, "").replace(",", ".");
    //     const parsed = parseFloat(raw) || 0;
    //     // Mimic the (event, value) signature used by TabNav handlers
    //     onChange({ target: { name } }, parsed);
    // };

    const handleChange = (e) => {
        if (!onChange) return;

        let raw = e.target.value
            .replace(",", ".")
            .replace(/[^\d.-]/g, "");

        // Only allow leading minus
        raw = raw.replace(/(?!^)-/g, "");

        // Prevent multiple decimals
        const parts = raw.split(".");
        if (parts.length > 2) {
            raw = parts[0] + "." + parts.slice(1).join("");
        }

        // Allow temporary typing states
        if (raw === "-" || raw === "." || raw === "-.") {
            onChange({ target: { name } }, raw);
            return;
        }

        const parsed = parseFloat(raw);

        onChange(
            { target: { name } },
            isNaN(parsed) ? "" : parsed
        );
    };

    const displayValue = disabled
        ? new Intl.NumberFormat("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value ?? 0)
        : value ?? 0;

    return (
        <TextField
            style={{ padding: 10 }}
            size="small"
            label={label}
            variant="outlined"
            name={name}
            value={displayValue}
            onChange={handleChange}
            disabled={disabled}
            InputProps={{
                startAdornment: <InputAdornment position="start">€</InputAdornment>,
            }}
            inputProps={{ inputMode: "decimal", step: "0.01" }}
        />
    );
}
